import { Icon, Spinner } from '@acpaas-ui/react-components';
import { useLayoutEffect, useRef } from 'react';
import { SIDEBAR_TABS } from '../../constants/settings.constants';
import DossierSidebarActivity from './activity/DossierSidebarActivity';
import DossierSidebarComments from './comments/DossierSidebarComments';

const DossierSidebarContent = ({
  user,
  involved = [],
  activities = [],
  comments = [],
  updatingCommentId,
  onCommentAction,
  commentEditForm,
  openedTab,
  error,
  isLoading
}) => {
  const contentRef = useRef(null);

  useLayoutEffect(() => {
    let isScrolled = false;
    if (!isScrolled && !error && !isLoading && openedTab && contentRef.current) {
      contentRef.current?.scrollTo(0, contentRef.current?.scrollHeight);
      isScrolled = true;
    }
  }, [error, isLoading, openedTab]);

  return (
    <div
      ref={contentRef}
      className={`spo-o-dossier-sidebar__content ${openedTab === SIDEBAR_TABS.COMMENTS ? 'comments' : ''} ${
        error || isLoading ? 'no-margin-top' : ''
      }`}
    >
      {isLoading ? (
        <Spinner className="spo-o-dossier-sidebar__content-loading" />
      ) : error ? (
        <p className="spo-o-dossier-sidebar__content-error u-text-danger">
          <Icon name="ai-alert-triangle" />
          <span className="u-margin-left-xs">
            Kan de {openedTab === SIDEBAR_TABS.ACTIVITY ? 'activiteit' : 'commentaar'} niet laden.
          </span>
        </p>
      ) : (
        <>
          {openedTab === SIDEBAR_TABS.ACTIVITY && <DossierSidebarActivity items={activities} />}
          {openedTab === SIDEBAR_TABS.COMMENTS && (
            <DossierSidebarComments
              involved={involved}
              user={user}
              items={comments}
              updatingCommentId={updatingCommentId}
              commentEditForm={commentEditForm}
              onCommentAction={onCommentAction}
            />
          )}
        </>
      )}
    </div>
  );
};

export default DossierSidebarContent;
